<template>
  <v-container
    fluid
    pa-0
    fill-height
    class="align-start"
    style="max-width: 100%"
  >
    <div class="d-flex flex-grow-1 fill-height">
      <MasterdataNavigation />
      <router-view />
    </div>
  </v-container>
</template>

<script>
import MasterdataNavigation from '@/modules/masterdata/components/MasterdataNavigation'

export default {
  name: 'Masterdata',

  components: {
    MasterdataNavigation
  }
}
</script>
